// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-item-title[data-v-64a5d47e]{color:#545454;letter-spacing:.53px;font-weight:700}.small[data-v-64a5d47e]{font-size:12px;margin-bottom:4px;margin-left:8px}.normal[data-v-64a5d47e]{font-size:14px;margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
